<template>
  <b-form-group
    label="Firma Adı"
    label-for="company"
  >
    <validation-provider
      #default="{ errors }"
      name="Firma Adı"
      rules="required"
    >
      <b-form-input
        id="company"
        v-model="dataItem.company"
        placeholder="Firma Adı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'

export default {
  name: 'Company',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['suppliers/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
